import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { isCommonReady, LoadGuard, RouteKey } from '@contact/upgrade';

import { HypervisionDetailedComponent } from './detailed-view/detailed-view.component';
import { HypervisionComponent } from './hypervision.component';
import { HypervisionSkillCustomComponent } from './skill-view/custom/custom.component';
import { HypervisionSkillSyntheticComponent } from './skill-view/synthetic/synthetic.component';
import { HypervisionSyntheticComponent } from './synthetic-view/synthetic-view.component';

export enum HypervisionState {
  DETAILED = 'detailed',
  SKILL_CUSTOM = 'skill-custom',
  SKILL_SYNTHETIC = 'skill-synthetic',
  SYNTHETIC = 'synthetic',
}

const routes: Routes = [
  {
    path: '',
    canActivate: [LoadGuard.forSelectors([isCommonReady])],
    data: {
      [RouteKey.RequiresAuth.key]: true,
    },
    component: HypervisionComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: HypervisionState.DETAILED,
      },
      {
        path: HypervisionState.DETAILED,
        component: HypervisionDetailedComponent,
      },
      {
        path: HypervisionState.SKILL_CUSTOM,
        component: HypervisionSkillCustomComponent,
      },
      {
        path: HypervisionState.SKILL_SYNTHETIC,
        component: HypervisionSkillSyntheticComponent,
      },
      {
        path: HypervisionState.SYNTHETIC,
        component: HypervisionSyntheticComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HypervisionRoutingModule {}
